import { render, staticRenderFns } from "./UserTaxCard.vue?vue&type=template&id=25bfa6d4&scoped=true&"
import script from "./UserTaxCard.vue?vue&type=script&lang=js&"
export * from "./UserTaxCard.vue?vue&type=script&lang=js&"
import style0 from "./UserTaxCard.vue?vue&type=style&index=0&id=25bfa6d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bfa6d4",
  null
  
)

export default component.exports